export const LEGAL_LINKS = {
  privacy: 'https://korlink.io/privacy-policy.html',
  terms: 'https://korlink.io/terms-of-service.html',
};
